import React from 'react';
import { FormatComponentProps } from './types';
import { GfBorderWrapper } from '../../../gfcomponents/GfBorderWrapper/GfBorderWrapper';

const FormulaBlock: React.FC<FormatComponentProps> = ({ content, formulaSelected }) => {
  const formulaMatch = content.match(/<FORMULA>([\s\S]*?)<\/FORMULA>/);
  const formula = formulaMatch ? formulaMatch[1] : '';
  return (
    <div onClick={() => formulaSelected?.(formula)}>
      <GfBorderWrapper>
        <span style={{ padding: '4px', cursor: 'pointer' }}>{formula.trim()}</span>
      </GfBorderWrapper>
    </div>
  );
};

export default FormulaBlock;
